import React, { useEffect, useState } from "react";
import { GridColDef } from '@mui/x-data-grid';
import GenericTable from "../GenericTable/GenericTable";
import { ConteudoObjTable, ConteudoTable } from "../../store/ducks/conteudo/types";
import dayjs from "dayjs";

const con: ConteudoObjTable[] = [];
const col: GridColDef[] = [];

const ConteudoTableComponent = (props: any) => {

    const [txtBusca, setTxtBusca] = useState('');
    const [columns, setColumns] = useState(col);
    const [listConteudo, setListConteudo] = useState(con);
    const [size, setSize] = useState(10);
    const [page, setPage] = useState(0);
    const [totalElements, setTotalElements] = useState(0);
    const [totalPages, setTotalPages] = useState(0);
    const [numberElements, setNumberElements] = useState(0);
    const [offset, setOffset] = useState(0);
    const [contTipo, setContTipo] = useState([0]);

    useEffect(() => {
        generateColumnsTable();
    }, []);

    useEffect(() => {
        if(props.data){
            tranformObjectTable(props.data)
        }
    }, [props.data]);

    const generateColumnsTable = () => {
        const _columns: GridColDef[] = [
            { field: 'nmConteudo', headerName: 'Nome', width: 300 },
            { field: 'dsConteudo', headerName: 'Descrição', width: 300 },
            { field: 'dtConteudoInicio', headerName: 'Data Início', width: 95 },
            { field: 'dtConteudoFim', headerName: 'Data Fim', width: 95 },
            { field: 'nmConteudoTipo', headerName: 'Tipo', width: 120 },
            { field: 'dsTempoEstimado', headerName: 'Duração', width: 80 },
        ];

        setColumns(_columns);
    };

    const tranformObjectTable = (obj: ConteudoTable) => {
        setSize(obj.size);
        setPage(obj.number);
        setTotalElements(obj.totalElements);
        setTotalPages(obj.totalPages);
        setNumberElements(obj.numberOfElements);
        setOffset(obj.pageable.offset)

        let list: ConteudoObjTable[] = obj.content.map((item: any) => {
            return {
                id: item[0],
                idConteudo: item[0],
                nmConteudo: item[1],
                dsConteudo: item[2],
                dtConteudoInicio: dayjs(item[3]).locale('pt-br').format('L'),
                dtConteudoFim: dayjs(item[4]).locale('pt-br').format('L'),
                nmConteudoTipo: item[5],
                dsTempoEstimado: item[6]
            }
        });

        setListConteudo(list);
    };
    
    const onPageChange = (pageIdx: any) => {
        props.body.pagina = pageIdx - 1;
        setPage(pageIdx - 1)
        props.onChange(props.body);
    }

    const onSizeChange = (_size: any) => {
        props.body.tamanho = _size;
        setSize(_size);
        props.onChange(props.body);
    }

    const onChangeBusca = (txt: string) => {
        props.body.txtBusca = txt;
        setTxtBusca(txt);
        if(txt.length >= 3){
            props.onChange(props.body);
        } else {
            props.body.txtBusca = '';
            props.onChange(props.body);
        }
    }

    const onSortChange = (sort: any) => {
        if(sort != undefined) {
            let colunaSort = sort.field && 
            sort.field == "nmConteudo" ? 'nmConteudo' 
            : sort.field == "dsConteudo" ? 'dsConteudo'
            : sort.field == "dsConteudo" ? 'dsConteudo'
            : sort.field == "dtConteudoInicio" ? 'dtConteudoInicio'
            : sort.field == "dtConteudoFim" ? 'dtConteudoFim'
            : sort.field == "dsTempoEstimado" ? 'dsTempoEstimado'
            : sort.field == "nmConteudoTipo" ? 'conteudoTipo.nmConteudoTipo' : 'nmConteudo' ;

            props.body.coluna = colunaSort;
            props.body.ordem = sort.sort.toUpperCase();
        } else {
            props.body.coluna = 'nmConteudo';
            props.body.ordem = 'ASC';
        }
        props.onChange(props.body);

    }

    const onChangeTipo = (tipos: any) => {
        if(tipos.length == 1 && tipos[0] == 0){
            props.body.idsConteudoTipo = [2, 5, 6, 7, 8, 9];
            setContTipo([0]);
        } else {
            props.body.idsConteudoTipo = tipos;
            setContTipo(tipos);
        }

        props.onChange(props.body);
    }

    return (
        <GenericTable 
            loading={props.loading}
            titleTable='Conteúdos Cadastrados'
            rows={listConteudo} 
            columns={columns} 
            page={page} 
            totalPages={totalPages} 
            onPageChange={onPageChange}
            offset={offset}
            numberElements={numberElements} 
            totalElements={totalElements}
            size={size}
            sizeChange={onSizeChange}
            txtBusca={txtBusca}
            onChangePesquisa={onChangeBusca}
            selection={props.selection}
            idSelectionChange={(arr: any) => props.idSelectionChange(arr)}
            sortChange={onSortChange}
            isConteudo={true}
            contTipo={contTipo}
            changeTipo={onChangeTipo}
        />
    )
};

export default ConteudoTableComponent;